import { Graphics, Text } from "@pixi/react";
import { TextStyle } from "pixi.js";
import { useTranslation } from "react-i18next";

type P = {
  rectWidth: number;
  rectHeight: number;
  /** Y position of issue description text */
  posY: number;
};

export function EmptyBackgroundText({ rectWidth, rectHeight, posY }: Readonly<P>) {
  const { t } = useTranslation();

  return (
    <>
      <Graphics
        draw={g => {
          g.beginFill(0xffffff);
          g.drawRect(0, 0, rectWidth, rectHeight);
          g.endFill();
        }}
      />
      <Text
        data-testid="empty-background-issue-description1"
        text={t("_emptyBackgroundIssueDescription1")}
        style={new TextStyle({ fontSize: 15, letterSpacing: 1, fill: 0x000000 })}
        resolution={2}
        x={5}
        y={posY}
      />
      <Text
        data-testid="empty-background-issue-description2"
        text={t("_emptyBackgroundIssueDescription2")}
        style={new TextStyle({ fontSize: 15, letterSpacing: 1, fill: 0x000000 })}
        resolution={2}
        x={5}
        y={posY + 20}
      />
    </>
  );
}
